module.exports = __webpack_public_path__ + "static/media/400167_01.9605291a.png";